module.exports = __webpack_public_path__ + "img/facebook.aee2e5f6.svg";